export const POLIZA_CONCEPTO_DEFAULT = "Póliza / Seguro integral";

export const ALQUILER_DEFAULT = [
  { nombre: "Andamios", gasto_mensual: 0 },
  { nombre: "Maquinaria", gasto_mensual: 0 },
  { nombre: "Elevadores", gasto_mensual: 0 },
];

const num = (v) => parseFloat(v) || 0;

// Lista presente (aunque vacía) manda; ausente adapta el importe único legado una sola vez.
export function resolvePolizas(init) {
  const src = init || {};
  if (Array.isArray(src.polizas)) {
    return src.polizas.map((p) => ({ concepto: p?.concepto ?? "", monto: p?.monto ?? 0 }));
  }
  return [{ concepto: POLIZA_CONCEPTO_DEFAULT, monto: num(src.poliza) }];
}

export const polizasTotal = (items) => (items || []).reduce((s, p) => s + num(p?.monto), 0);

export function resolveAlquiler(init) {
  const src = init || {};
  if (Array.isArray(src.alquiler_items)) {
    return src.alquiler_items.map((a) => ({ nombre: a?.nombre ?? "", gasto_mensual: a?.gasto_mensual ?? 0 }));
  }
  return ALQUILER_DEFAULT.map((a) => ({ ...a }));
}

export const alquilerMensual = (items) => (items || []).reduce((s, a) => s + num(a?.gasto_mensual), 0);

// Mismo patrón que gastos menores: gasto mensual × meses de obra (hh_meses_duracion / hhLive.meses).
export const alquilerTotal = (items, meses) => alquilerMensual(items) * (parseFloat(meses) || 0);

export function polizasPayload(items) {
  const clean = (items || []).map((p) => ({ concepto: String(p?.concepto ?? ""), monto: num(p?.monto) }));
  return { polizas: clean, poliza: polizasTotal(clean) };
}
